// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__-3NJU","spinner":"Loader_spinner__QrU8H","spin":"Loader_spin__8TnK+","message":"Loader_message__sK5v5"};